import { render } from "./SenaraiNotis2A.vue?vue&type=template&id=85fc42d8"
import script from "./SenaraiNotis2A.vue?vue&type=script&lang=js"
export * from "./SenaraiNotis2A.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__